export class SubcategoryAddModel {
    public name: string;
    public parentId: string;
    constructor() {
        this.parentId = '';
    }
}
